(function processBatchModuleDefinition() {
    'use strict';

    angular.module('ProcessBatch', ['ngFileUpload', 'ui.router', 'Config', 'Entities', 'CustomControls', 'ui.select', 'ui.selectExtend', 'TranslatedPaginator'
        , 'ClickOnce', 'FileDownloader', 'DoublyLinkedList', 'Process', 'DocumentViewer'
    ])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function processBatchConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('process-batch-find', {
                    url: "/ProcessBatch/Find",
                    templateUrl: config.resourceUrl('/views/process-batch/process-batch-find.html'),
                    controller: 'ProcessBatchFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PROCESS ASYNC')
                });

                $stateProvider.state('process-batch-detail', {
                    url: "/ProcessBatch/Detail/{id}",
                    templateUrl: config.resourceUrl('/views/process-batch/process-batch-detail.html'),
                    controller: 'ProcessBatchDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PROCESS ASYNC')
                });
            }
        ]);
})();
